import {LicenseInfo} from '@mui/x-data-grid-pro';

import React, {lazy, Suspense, useCallback, useContext, useEffect} from 'react';

import {Navigate, Outlet, Route, Routes, useLocation} from 'react-router-dom';
import CenteredBox from "./components/ui/CenteredBox";
import {LoadingButton} from "@mui/lab";
import {AuthContext, PageContext} from "@lb/mlib-components";
import {trackScreen} from "./utils/reactGA";

LicenseInfo.setLicenseKey(
  '88516f036af68aed3fba46f1c8c5bd84Tz0xMDQwNzksRT0xNzY1NDgxMjM2MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=',
);

const ViewSecret = lazy(() => import("./screens/employee/Access/SecretsTabPanel/ViewSecret"));
const JotFormUpload = lazy(() => import("./screens/JotFormUpload"));
const Home = lazy(() => import("./screens/Home"));
const SignIn = lazy(() => import("./screens/SignIn"));
const Upload = lazy(() => import('./screens/customer/Upload'));
const Download = lazy(() => import('./screens/customer/Download'));
const Dashboard = lazy(() => import('./screens/employee/Dashboard'));
const Access = lazy(() => import('./screens/employee/Access'));
const TransferToCustomer = lazy(() => import('./screens/employee/TransferToCustomer'));
const TransferFromCustomer = lazy(() => import('./screens/employee/TransferFromCustomer'));

const Forbidden = lazy(() => import("./screens/403"));
const NotFound = lazy(() => import("./screens/404"));


export default function TransferRoutes() {
  const authCtx = useContext(AuthContext)
  const location = useLocation()

  // track location(url-pathname) change to kick out user without api call
  const isLoggedIn = useCallback(() => location && authCtx.isLoggedIn(), [authCtx, location])

  const ProtectedRoute = useCallback(({isAllowed, redirectPath}) => {
    if (isAllowed) return <Outlet/>
    else {
      if (redirectPath) return <Navigate to={redirectPath} replace/>
      else return <Forbidden/>
    }
  }, [])

  const pageCtx = useContext(PageContext);

  useEffect(() => {
        trackScreen(pageCtx.title + ' - ' + location.pathname);
    }, [pageCtx.title]);

  useEffect(() => {
    if (window.location.pathname !== '/login')
      pageCtx.updateCurrentUrl(window.location.pathname)
  }, [pageCtx])

  return (<Suspense fallback={<CenteredBox><LoadingButton loading> </LoadingButton></CenteredBox>}>
      <Routes>

        {/* `Shared` paths */}
        <Route path="viewsecret">
          <Route path=":token" element={<ViewSecret/>}/>
        </Route>
        <Route path="jotform-upload" element={<JotFormUpload/>}/>
        <Route path='upload'>
          <Route path=':token' element={<Upload/>}/>
        </Route>
        <Route path='dnload'>
          <Route path=':token' element={<Download/>}/>
        </Route>

        {/* `Not logged in` routes */}
        <Route element={<ProtectedRoute isAllowed={!isLoggedIn()} redirectPath='access'/>}>

          <Route path='/' element={<Home/>}/>
          <Route path='login' element={<SignIn/>}/>

        </Route>

        {/* `Logged in` routes*/}
        <Route element={<ProtectedRoute isAllowed={isLoggedIn()} redirectPath='login'/>}>
          <Route path='login' element={<Navigate to='access' replace/>}/>

          <Route element={<Dashboard children={<Outlet/>}/>}>
            <Route path='access' element={<Access/>}/>

            <Route path='tocustomer'>
              <Route path=':transferId'>
                <Route index element={<TransferToCustomer/>}/>
                <Route path=':tab' element={<TransferToCustomer/>}/>
              </Route>
            </Route>

            <Route path='fromcustomer'>
              <Route path=':transferId'>
                <Route index element={<TransferFromCustomer/>}/>
                <Route path=':tab' element={<TransferFromCustomer/>}/>
              </Route>
            </Route>
          </Route>

          <Route path='*' element={<NotFound/>}/>
        </Route>

      </Routes>
      {/*____________________________________________________________________________________________________*/
      }
      {/*____________________________________________________________________________________________________*/
      }
      {/*____________________________________________________________________________________________________*/
      }
      {/*<Routes>*/}
      {/*  <PublicRoute exact path="/" component={Home} authenticated={authenticated}/>*/}
      {/*  <PublicRoute exact path="/login" component={SignIn} authenticated={authenticated}/>*/}
      {/*  <PublicRoute exact path="/upload/:token" component={Upload} authenticated={authenticated}/>*/}
      {/*  <PublicRoute exact path="/dnload/:token" component={Download} authenticated={authenticated}/>*/}
      {/*  <Route exact path="/viewsecret/:token" component={ViewSecret}/>*/}
      {/*  <Route exact path="/jotform-upload" component={JotFormUpload}/>*/}

      {/*  <PrivateRoute component={Dashboard} authenticated={authenticated}>*/}
      {/*    <Route exact path="/access" component={Access}/>*/}
      {/*    <Route exact path="/tocustomer/:transferId" component={TransferToCustomer}/>*/}
      {/*    <Route exact path="/tocustomer/:transferId/:tab" component={TransferToCustomer}/>*/}
      {/*    <Route exact path="/fromcustomer/:transferId" component={TransferFromCustomer}/>*/}
      {/*    <Route exact path="/fromcustomer/:transferId/:tab" component={TransferFromCustomer}/>*/}
      {/*    /!*<Redirect to="/access"/>*!/*/}
      {/*  </PrivateRoute>*/}


      {/*  /!*<Route path='/' exact>{!authCtx.isLoggedIn ? <Home/> : <Redirect to='/access'/>}</Route>*/}
      {/*  <Route path='/login' exact>{authCtx.isLoggedIn ? <Redirect to='/access'/> : <SignIn/>}</Route>*/}
      {/*  <Route path='/upload/:token' exact><Upload/></Route>*/}
      {/*  <Route path='/dnload/:token' exact><Download/></Route>*/}
      {/*  <Route path="/viewsecret/:token" exact component={ViewSecret}/>*/}
      {/*  <Route path="/jotform-upload" exact component={JotFormUpload}/>*/}
      {/*  <Dashboard>*/}
      {/*    <Route path='/access' exact>{!authCtx.isLoggedIn ? <Redirect to='/login'/> : <Access/>}</Route>*/}
      {/*    <Route path='/tocustomer/:transferId' exact>{!authCtx.isLoggedIn ? <Redirect to='/login'/> :*/}
      {/*      <TransferToCustomer/>}</Route>*/}
      {/*    <Route path='/tocustomer/:transferId/:tab' exact>{!authCtx.isLoggedIn ? <Redirect to='/login'/> :*/}
      {/*      <TransferToCustomer/>}</Route>*/}
      {/*    <Route path='/fromcustomer/:transferId' exact>{!authCtx.isLoggedIn ? <Redirect to='/login'/> :*/}
      {/*      <TransferFromCustomer/>}</Route>*/}
      {/*    <Route path='/fromcustomer/:transferId/:tab' exact>{!authCtx.isLoggedIn ? <Redirect to='/login'/> :*/}
      {/*      <TransferFromCustomer/>}</Route>*/}

      {/*  </Dashboard>*/}
      {/*  <Route path='*'>*/}
      {/*    <Redirect to='/login'/>*/}
      {/*  </Route>*!/*/}
      {/*</Routes>*/}
    </Suspense>
  )
}
